const TRIGGER = 'trigger'

export default function () {
  let $elements = document.querySelectorAll('[data-module="coeur"]')

  setTimeout(function () {
    for (let i = 0; i < $elements.length; i++) {
      init($elements[i])
    }
  }, 1000)
}

function init ($element) {
  $element.classList.add(TRIGGER)
}
